import { useEffect } from 'react';
import { getBoardPerRoles, assignBoardRoles } from '../../../api/adminAPI';
import { getBoardsWithRootCategory } from '../../../api/boardApi';
import { useAdminAPI } from './useAdminAPI';

export interface Board {
    board_id: number;
    name: string;
    [key: string]: any;
    rootCategories: any[];
    categoryType: string;
    isPermissionEnabled: boolean;
    isCategoryPermissionEnabled: boolean;
}

interface BoardsResponse {
    resultCode: string;
    message: string;
    data: Board[];
}

interface BoardRolesResponse {
    resultCode: string;
    message: string;
    data: any[];
}

type BoardRoles = "TOTAL";
// type BoardRoles = "WRITE" | "READ" | "DELETE";

interface AssignBoardRoleParams {
    boardId: number;
    userId: number;
    boardRoles: BoardRoles[];
}

/**
 * 게시판 목록 조회를 위한 커스텀 훅
 *
 * @returns boards, loading, error, refetch
 */
export const useBoards = () => {
    const { data, loading, error, execute, refetch } = useAdminAPI<BoardsResponse>(getBoardsWithRootCategory);

    useEffect(() => {
        execute();
    }, []);

    return {
        boards: data?.data || [],
        loading,
        error,
        refetch,
    };
};

/**
 * 게시판 별 역할 목록 조회를 위한 커스텀 훅
 *
 * @param boardId - 게시판 ID
 * @returns roles, loading, error, refetch
 */
export const useBoardRoles = (boardId?: number) => {    
    const { data, loading, error, execute } = useAdminAPI<BoardRolesResponse>(
        getBoardPerRoles,
        false
    );

    useEffect(() => {
        if (boardId) {
            execute({ boardId });
        }
    }, [boardId]);

    return {
        roles: data?.data || [],
        loading,
        error,
        refetch: () => boardId ? execute({ boardId }) : Promise.resolve(),
    };
};

/**
 * 게시판 역할 할당을 위한 커스텀 훅
 *
 * @returns assignRole, loading, error
 */
export const useAssignBoardRole = () => {
    const { loading, error, execute } = useAdminAPI(assignBoardRoles, false);

    const assignRole = async (params: AssignBoardRoleParams) => {
        console.log({params});
        
        return await execute(params);
    };

    return {
        assignRole,
        loading,
        error,
    };
};
